import usePaginatedRegisters from '@/modules/PaginatedRegisters.js'

import { computed, ref } from 'vue'

import axios from 'axios'

const noncompliance_models_dropdown = ref([])
const noncompliance_model_form_data = ref(new FormData())

const noncompliance_models = ref([])
const total_noncompliance_models = ref(0)
const noncompliance_model_filters = ref({})
const loading = ref(false)

export default function useNoncomplianceModels() {
  const {
    get_api_path,
    save_api_path,
    destroy_api_path,
    destroyRegister,
    saveRegister,
    getRegister,
  } = usePaginatedRegisters()

  get_api_path.value = '/api/noncompliance_models/get/'
  save_api_path.value = '/api/noncompliance_models/storeOrUpdate'
  destroy_api_path.value = '/api/noncompliance_models/destroy/'

  const destroyNoncomplianceModel = async (id, index) => {
    destroyRegister(id).then(() => {
      noncompliance_models.value.splice(index, 1)
    })
  }

  const listNoncomplianceModels = async (page = 1, per_page = 10) => {
    loading.value = true

    var filters = Object.keys(noncompliance_model_filters.value)
      .filter(Boolean)
      .map((key) => ({ [key]: noncompliance_model_filters.value[key] }))
      .reduce((result, current) => Object.assign(result, current), {})

    return new Promise((resolve, reject) => {
      axios
        .get('/api/noncompliance_models/searchAndPaginate', {
          params: Object.assign(
            {
              page,
              per_page,
            },
            filters,
          ),
        })
        .then(function (response) {
          total_noncompliance_models.value = response.data.meta.total
          noncompliance_models.value = response.data.data
          noncompliance_models_dropdown.value = noncompliance_models.value.map(
            (item) => ({ label: item.description, value: item.id }),
          )
        })
        .catch(function (error) {
          reject(error)
        })
        .finally(() => (loading.value = false))
    })
  }

  const listNoncomplianceModelsNoPagination = async () => {
    await axios
      .get('/api/noncompliance_models/all-without-pagination')
      .then(function (response) {
        noncompliance_models.value = response.data.data
        noncompliance_models_dropdown.value = noncompliance_models.value.map(
          (item) => ({ label: item.description.slice(0, 150), value: item.id }),
        )
      })
      .catch(function () {})
  }

  const listNoncomplianceModel = async (id) => {
    await axios
      .get('/api/noncompliance_models/get/' + id)
      .then(function (response) {
        noncompliance_model_form_data.value = response.data.data
      })
      .catch(function () {})
  }

  return {
    noncompliance_models: computed(() => noncompliance_models.value),
    noncompliance_models_dropdown,
    noncompliance_model_filters: noncompliance_model_filters,
    noncompliance_model_form_data: noncompliance_model_form_data,
    total_noncompliance_models,
    loading,
    listNoncomplianceModels,
    listNoncomplianceModelsNoPagination,
    listNoncomplianceModel,
    getNoncomplianceModel: getRegister,
    saveNoncomplianceModel: saveRegister,
    destroyNoncomplianceModel,
  }
}
